const Header = () => {
    const storageKey = 'font-size-preference'

    const changeFontsize = document.querySelectorAll('.block-fontsize .option')

    changeFontsize.forEach(function (btn) {
        btn.addEventListener('click', function () {
        let selectedFontsize = btn.dataset.fontsize

        fontsize.value = selectedFontsize
        setPreference()
        })
    })

    const getFontSizePreference = () => {
        if (localStorage.getItem(storageKey))
        return localStorage.getItem(storageKey)
        else
        return'16'
    }

    const setPreference = () => {
        localStorage.setItem(storageKey, fontsize.value)
        reflectPreference()
    }

    const reflectPreference = () => {
        document.firstElementChild.style.fontSize = fontsize.value + 'px'

        let activeOption = document.querySelectorAll('.block-fontsize .option.actived')

        if(activeOption){
            activeOption.forEach(function (btn) {
                btn.classList.remove('actived')
            })
        }

        const setActiveOption = document.querySelectorAll('.block-fontsize [data-fontsize="' + fontsize.value + '"]')
        setActiveOption.forEach(function (btn) {
            btn.classList.add('actived')
        })
    }

    const fontsize = {
        value: getFontSizePreference(),
    }

    reflectPreference()

    window.onload = () => {
        reflectPreference()
    }

    document.addEventListener('DOMContentLoaded', () => {
        const accordionButtons = document.querySelectorAll('.title-menu');

        accordionButtons.forEach(button => {
            button.addEventListener('click', function () {
                const target = document.querySelector(this.getAttribute('data-target'));

                // Toggle the display of the target element
                if (target.classList.contains('expanded')) {
                    target.classList.remove('expanded');
                    target.parentElement.classList.remove('open');
                    this.setAttribute('aria-expanded', 'true');
                } else {
                    target.classList.add('expanded');
                    target.parentElement.classList.add('open');
                    this.setAttribute('aria-expanded', 'false');
                }

                // Hide all other accordion contents
                document.querySelectorAll('.accordion-collapse').forEach(collapse => {
                    if (collapse !== target) {
                        collapse.classList.remove('expanded');
                    }
                });

                // Update the button states
                accordionButtons.forEach(btn => {
                    if (btn !== this) {
                        btn.setAttribute('aria-expanded', 'false');
                    }
                });
            });
        });
    });
};

export default Header;
